import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { ExclamationIcon } from '@heroicons/react/outline';

const Terms = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const terms = [
    "الدورة وكل ما يتعلق فيها من محاضرات واختبارات وحقائب تدريبية هي للمتدرب المسجل فقط، ولا يُسمح مشاركتها أو إرسالها أو تسجيلها والاستفادة منها لغير المتدرب.",
    "الاشتراك الواحد لمتدرب واحد فقط ولا يُسمح بدخول أكثر من شخص في نفس الحساب.",
    "نظام الاشتراك في دوراتنا يسمح بالاستفادة من المحتوى في وقت محدد ولا يُسمح بتسجيله أو حفظه",
    "لا يمكن الانسحاب من الدورة أو طلب استرجاع رسومها بعد تفعيل الحساب.",
    "الدورة إلكترونية وتحتاج إلى إنترنت بسرعة جيدة لذلك لا تتحمل منصة دوز التعليمية أي مشاكل ناتجة عن ضعف الإنترنت.",
    "تحذف الدورة بكامل محتوياتها تلقائيا بعد انتهاء مدة الاشتراك الموضحة في معلومات الدورة."
  ];

  return (
    <div className={`min-h-screen py-16 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>  
      <div className="max-w-5xl mx-auto px-4">  
        <div className={`p-8 rounded-lg ${isDark ? 'bg-gray-800' : 'bg-white border border-gray-200'}`}>  
          {/* العنوان */}
          <div className="text-center mb-10">
            <div className="mb-6 flex justify-center">
              <div className={`p-3 rounded-full ${isDark ? 'bg-primary-900/20' : 'bg-primary-100'}`}>
                <ExclamationIcon className="h-8 w-8 text-primary-600 dark:text-primary-400" />
              </div>
            </div>
            <h1 className={`text-3xl md:text-4xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>الشروط والأحكام</h1>
            <p className={`text-lg ${isDark ? 'text-white' : 'text-gray-600'}`}>
              يرجى قراءة الشروط والأحكام بعناية قبل استخدام المنصة
            </p>
          </div>

          {/* الشروط */}
          <div className="space-y-6">
            {terms.map((term, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 space-x-reverse"
              >
                <div className="flex-shrink-0">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    isDark ? 'bg-gray-700/50' : 'bg-gray-100'
                  }`}>
                    <span className="text-primary-600 dark:text-primary-400 font-semibold">{index + 1}</span>
                  </div>
                </div>
                <p className={`text-lg flex-1 ${isDark ? 'text-white' : 'text-gray-600'}`}>
                  {term}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
